var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_DOWNLOAD_BULK_STATUS_REQUEST, fetchDownloadBulkStatusFailure, fetchDownloadBulkStatusSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const onFetchDownloadBulkStatus = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const sync = yield APIIN.get(`/cnvt/bulk/${action.payload.bulkId}/status`);
            resolve(sync);
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchDownloadBulkStatusWorker(action) {
    try {
        let data = yield call(onFetchDownloadBulkStatus, action);
        data = JSON.parse(data.slice(5));
        yield put(fetchDownloadBulkStatusSuccess(data));
    }
    catch (error) {
        yield put(fetchDownloadBulkStatusFailure(error));
    }
}
export function* watchDownloadBulkStatus() {
    yield takeLatest(FETCH_DOWNLOAD_BULK_STATUS_REQUEST, fetchDownloadBulkStatusWorker);
}
